import { assetsConstants } from "../../../actions/precog/assets";

const defaultState = {
  status: {
    started: false,
    ended: false,
    error: false
  }, 
  list: []
};

export function fixedAssets(state = defaultState, { type, payload, error}) {
  switch (type) {
  case assetsConstants.GET_FIXED_ASSETS_LIST_START:
    return {
      ...state,
      status: {
        started: true,
        ended: false,
        error: false
      }
    };
  case assetsConstants.GET_FIXED_ASSETS_LIST_SUCCESS:
    return {
      ...state, 
      status: {
        started: false,
        ended: true,
        error: false
      },
      list: payload?.toAdded ? state?.list.concat(payload?.data?._embedded?.elements) : payload?.data?._embedded?.elements,
      totals: {
        totalAmount: payload?.data?._embedded?.totalAmount,
        totalDepreciatedAmount: payload?.data?._embedded?.totalDepreciatedAmount,
        totalResidualAmount: payload?.data?._embedded?.totalResidualAmount
      },
      nextUrl: payload?.data?._links?.next?.href
    };
  case assetsConstants.GET_FIXED_ASSETS_LIST_ERROR:
    return {
      ...state,
      status: {
        started: false,
        ended: false,
        error: true
      }
    };
  default:
    return state;
  }
}